module.exports = __webpack_public_path__ + "static/media/stopping.5ca1dd98.mp3";